export default __webpack_public_path__ + "static/media/list_main_1_2.6387cbe7.png";